import { StringHelper } from "./string-helper";
import { DateHelper } from "./date-helper";
import { InvalidParameterError } from "../core/exception/invalid-parameter-error";

export class PeriodHelper {
	public static isValidFromTo(from: Date | string, to: Date | string) {
		if (from && to) {
			return new Date(from) <= new Date(to);
		}
		return true;
	}

	public static isWithinRange(from: Date | string, to: Date | string, dateToBeWithin: Date | string = DateHelper.today()) {
		let fromDate = new Date(from);
		let toDate = new Date(to);
		if (from && fromDate > new Date(dateToBeWithin) || to && toDate < new Date(dateToBeWithin)) {
			return false;
		}
		return true;
	}

	public static toString(from: Date | string, to: Date | string = null, ignoreIfSame: boolean = false, withYear: boolean = true, textIfOnlyFrom: string = "", textIfOnlyTo: string = "") {
		let result: string = "";
		let currentFrom = from instanceof Date ? from : new Date(from);
		let currentTo = to instanceof Date ? to : new Date(to);

		if (from) {
			result += `${StringHelper.pad(currentFrom.getDate())}.${StringHelper.pad(currentFrom.getMonth() + 1)}`;
			if (!to ||((new Date(from)).getFullYear() !== (new Date(to)).getFullYear()) && (!ignoreIfSame || (from === to))) {
				result += `.${withYear ? currentFrom.getFullYear() : ""}`;
			}
		}

		if (from && !to) {
			result = textIfOnlyFrom + result;
		}

		if ((from && to) && (!ignoreIfSame || from !== to)) {
			result += ` - `;
		}
		if (to && (!ignoreIfSame || from !== to)) {
			result += `${StringHelper.pad(currentTo.getDate())}.${StringHelper.pad(currentTo.getMonth() + 1)}.${withYear ? StringHelper.pad(
				currentTo.getFullYear()) : ""}`;
		}

		if (to && !from) {
			result += textIfOnlyTo;
		}

		return result;
	}

	public static daysBetweenWithoutTime(from: Date | string, to: Date | string, includeToDay: boolean = false) {
		if (!from) {
			throw new InvalidParameterError("from", InvalidParameterError.nullText);
		}
		if (!to) {
			throw new InvalidParameterError("to", InvalidParameterError.nullText);
		}

		if (typeof from === "string") {
			from = new Date(from);
		}

		if (typeof to === "string") {
			to = new Date(to);
		}

		let diff = DateHelper.dateDiffWithoutTime(from, to);
		let days = Math.trunc(diff.getTime() / DateHelper.dayInMs);
		return days + (includeToDay ? (Math.sign(days) * 1) : 0);
	}

	public static isSourceInsideTarget(fromSource: Date | string, toSource: Date | string, fromTarget: Date | string, toTarget: Date | string, excludeBorders: boolean = false): boolean {
		// all bordres open, so ok
		if (fromTarget == null && toTarget == null) {
			return true;
		}

		// source borders open, target not, so false
		if (fromSource == null && fromTarget != null
			|| toSource == null && fromTarget != null) {
			return false;
		}

		if (fromTarget != null) {
			let fromSourceDate = new Date(fromSource);
			let fromTargetDate = new Date(fromTarget);
			if (fromSourceDate < fromTargetDate
				|| (excludeBorders && fromSourceDate.getTime() === fromTargetDate.getTime())) {
				return false;
			}
		}

		if (toTarget != null) {
			let toSourceDate = new Date(toSource);
			let toTargetDate = new Date(toTarget);
			if (toSourceDate > toTargetDate
				|| (excludeBorders && toSourceDate.getTime() === toTargetDate.getTime())) {
				return false;
			}
		}
		return true;
	}
}